import Vue from 'vue'

Vue.filter('formatDate', formatDate)
Vue.prototype.formatDate = formatDate
Vue.prototype.moneyFormatter = moneyFormatter
function moneyFormatter (value) {
  let str = (value).toFixed(2) + ''
  // 取到整数部分
  let intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',')
  // 取到小数部分搜索
  let dot = str.substring(str.length, str.indexOf('.'))
  let ret = intSum + dot
  return ret
}
function formatDate (value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hours = date.getHours()
  var minutes = date.getMinutes()
  var secords = date.getSeconds()

  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (secords < 10) {
    secords = '0' + secords
  }
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + secords
}
Vue.filter('formatDateTime', function formatDateTime (value) {
  var date = new Date(value)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hours = date.getHours()
  var minutes = date.getMinutes()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes
})
Vue.filter('formatDateNoTime', function formatDateTime (value) {
  if (value && value.indexOf('-') > -1) {
    var date = new Date(Date.parse(value.replace(/-/g, '/')))
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day
  } else {
    return ''
  }
})
let enums = null
// 日期格式转时间戳
Vue.filter('theTime', function (dt) {
  var dtRet = ''
  if (dt) {
    var date = new Date(Date.parse(dt.replace(/-/g, '/')))

    dtRet = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours())

    return dtRet
  } else {
    return 0
  }
})
Vue.filter('coverEnum', function (code, name) {
  if (code === '') {
    return ''
  }
  if (enums == null) {
    let f = Vue.prototype.enums
    let json = {}
    for (let i in f) {
      json[i] = {}
      for (let n in f[i]) {
        json[i][f[i][n].code] = f[i][n].name
      }
    }
    enums = json
  }
  let enum2 = enums[name]
  if (enum2 && enum2[code]) {
    return enum2[code]
  } else {
    return ''
  }
})

// 可使用任意字符分隔的字符串（如多选品牌），返回多个码表中的数据
// type 分隔字符
Vue.filter('coverEnumList', function (code, name, type) {
  if (!code) {
    return ''
  }
  if (enums == null) {
    let f = Vue.prototype.enums
    let json = {}
    for (let i in f) {
      json[i] = {}
      for (let n in f[i]) {
        json[i][f[i][n].code] = f[i][n].name
      }
    }
    enums = json
  }
  let enum2 = enums[name] // {10: "是", 20: "否"}
  if (enum2) {
    if (code.indexOf(type) === -1) {
      if (enum2[code]) {
        return enum2[code]
      } else {
        return ''
      }
    } else {
      let codeList = code.split(type)
      let returnList = ' '
      for (let i = 0; i < codeList.length; i++) {
        returnList += enum2[codeList[i]] + ','
      }
      returnList = returnList.substring(0, returnList.length - 1)
      return returnList
    }
  } else {
    return ''
  }
})

let carInfos = {}
let cover = new Cover()
let _Vue = Vue
Vue.filter('coverCarInfo', function (value, grade) {
  return searchItem(value, grade, cover, carInfos, Vue.prototype.carInfos)
})
Vue.filter('coverCarInfoName', function (value, grade) {
  return searchName(value, grade, cover, carInfos, Vue.prototype.carInfos)
})
let regions = {}
Vue.filter('coverRegion', function (value, grade) {
  return searchItem(value, grade, cover, regions, _Vue.prototype.regionsSelect)
})
Vue.filter('coverRegionName', function (value, grade) {
  return searchName(value, grade, cover, regions, _Vue.prototype.regionsSelect)
})
function generatorSearchKey (value, grade) {
  return value + ':' + grade
}
function Cover () {
  this.codeKey = 'value'
  this.nameKey = 'label'
  this.itemKey = 'item'
  this.gradeKey = 'grade'
}
function init (keys, properties, prototype, func) {
  func = func || function () { console.log('-') }
  let property = properties['data']
  if (!property) {
    property = properties['data'] = {}
    core(prototype)
  }
  function core (children) {
    for (let i in children) {
      property[generatorSearchKey(children[i][keys.codeKey], children[i][keys.gradeKey])] = children[i]
      if (children[i].children && children[i].children.length > 0) {
        core(children[i].children)
      }
    }
  }
  return property
}
function searchItem (value, grade, keys, properties, prototype, func) {
  let property = init(keys, properties, prototype, func)
  let result = property[generatorSearchKey(value, grade)]
  if (result) {
    return result[keys.itemKey]
  } else {
    return value
  }
}
function searchName (value, grade, keys, properties, prototype, func) {
  let property = init(keys, properties, prototype, func)
  let result = property[generatorSearchKey(value, grade)]
  if (result) {
    return result[keys.nameKey]
  } else {
    return value
  }
}
